import { DateRange } from 'react-day-picker';
import React, { createContext, ReactNode, useState } from 'react';

import { Country, PartialFieldNames } from '../../types';

type TravelWidgetContextType = {
  countries: Country[];
  setCountries: React.Dispatch<React.SetStateAction<Country[]>>;
  selected: DateRange;
  setSelected: React.Dispatch<React.SetStateAction<DateRange>>;
  travellerCount: number;
  setTravellerCount: React.Dispatch<React.SetStateAction<number>>;
  setCurrentWidgetErrors: React.Dispatch<React.SetStateAction<PartialFieldNames | null>>;
  currentWidgetErrors: PartialFieldNames | null;
};

const TravelWidgetContext = createContext<TravelWidgetContextType | undefined>(undefined);

const TravelWidgetProvider = ({ children }: { children: ReactNode }) => {
  const [countries, setCountries] = useState<Country[]>([]);
  const [travellerCount, setTravellerCount] = useState<number>(0);

  const [selected, setSelected] = useState<DateRange>({
    from: undefined,
    to: undefined,
  });
  const [currentWidgetErrors, setCurrentWidgetErrors] = useState<PartialFieldNames | null>(null);

  const value = React.useMemo(
    () => ({
      countries,
      currentWidgetErrors,
      selected,
      setCountries,
      setCurrentWidgetErrors,
      setSelected,
      setTravellerCount,
      travellerCount,
    }),
    [
      countries,
      setCountries,
      selected,
      setSelected,
      setTravellerCount,
      travellerCount,
      currentWidgetErrors,
      setCurrentWidgetErrors,
    ],
  );

  return <TravelWidgetContext.Provider value={value}>{children}</TravelWidgetContext.Provider>;
};

export { TravelWidgetContext, TravelWidgetProvider };
